const MS_IN_A_DAY = 86400000; /* 1000 * 60 * 60 * 24 */

function isValidDate(date: string | null | undefined): date is string {
  if (!date || Number.isNaN(Date.parse(date))) {
    return false;
  }
  return true;
}

// true if expired
export function checkIfExpired(date: string | null): boolean {
  if (!isValidDate(date)) {
    return false;
  }
  return new Date(date) < new Date();
}

export function getFullDaysDiff(firstDate: string, secondDate: string): number | null {
  if (!isValidDate(firstDate) || !isValidDate(secondDate)) return null;

  return Math.floor(
    (new Date(secondDate).getTime() - new Date(firstDate).getTime()) / MS_IN_A_DAY
  );
}

export function howManyDaysLeft(date: string | null): number | null {
  if (!isValidDate(date)) return null;
  return getFullDaysDiff(new Date().toUTCString(), date);
}

/**
 * Parses a date-only string (YYYY-MM-DD) as LOCAL midnight. `new Date(str)`
 * parses such strings as UTC midnight, which formats as the previous day for
 * users west of UTC. Falls back to `new Date(str)` for full timestamps.
 */
export function parseDateOnly(date: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!match) return new Date(date);

  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}
